module.exports = __webpack_public_path__ + "static/video-poster-9e6b491522d2258b03cb99da2b3fe9b7.png";